<script setup lang="ts">
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { BellIcon, BellAlertIcon } from "@heroicons/vue/24/outline";
import useAlerts, { type Alert } from "@/composables/use-alerts";
import { useRouter } from "vue-router";
import { errorToast } from "@/util/toast";
import { useAuthStore } from "@/stores";

const router = useRouter();
const authStore = useAuthStore();

const { alerts } = useAlerts();

function openAlert(alert: Alert) {
  // const route = router.resolve({
  //   name: alert.route,
  // });
  if (authStore.masquerading && alert.route === "claim-nomination") {
    return errorToast("As an admin, you cannot claim nominations.", {
      timeout: 5000,
    });
  }
  router.push({ name: alert.route });
}
</script>

<template>
  <Popover class="relative flex flex-col justify-center" v-if="alerts.length">
    <PopoverButton
      class="inline-flex items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900 focus:ring-0"
    >
      <BellAlertIcon
        class="h-6 w-6 text-red-400"
        aria-hidden="true"
        v-if="alerts.length"
      />
      <BellIcon class="h-6 w-6" aria-hidden="true" v-else />
    </PopoverButton>

    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="opacity-0 translate-y-1"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 translate-y-1"
    >
      <PopoverPanel
        class="absolute left-1/2 z-10 mt-10 flex w-screen max-w-max -translate-x-3/4 translate-y-1/2 px-4"
      >
        <div
          class="w-screen max-w-md flex-auto overflow-hidden rounded-lg bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5"
        >
          <div class="p-4">
            <div
              v-for="item in alerts"
              :key="item.name"
              class="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-50"
            >
              <div
                class="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white"
              >
                <component
                  :is="item.icon"
                  class="h-6 w-6 text-gray-600"
                  aria-hidden="true"
                />
              </div>
              <div>
                <p
                  @click="openAlert(item)"
                  :class="`font-semibold ${
                    item.highlight || 'gray-900'
                  } cursor-pointer`"
                >
                  {{ item.name }}
                  <span class="absolute inset-0" />
                </p>
                <p :class="`mt-1 pr-2 ${item.highlight || 'gray-600'}`">
                  {{ item.description }}
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50">
            <a
              v-for="item in callsToAction"
              :key="item.name"
              :href="item.href"
              class="flex items-center justify-center gap-x-2.5 p-3 font-semibold text-gray-900 hover:bg-gray-100"
            >
              <component
                :is="item.icon"
                class="h-5 w-5 flex-none text-gray-400"
                aria-hidden="true"
              />
              {{ item.name }}
            </a>
          </div> -->
        </div>
      </PopoverPanel>
    </transition>
  </Popover>
</template>
